/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-07-24
 */

// Add third-party dependencies.
import { Box, Container, Typography, Button } from '@mui/material';
import { Close } from '@mui/icons-material';

// Add local dependencies.
import PrivacyContent from './PrivacyContent';

/**
 * Privacy Policy page component.
 * @example
 * return <Privacy />
 * @returns {React.ReactElement} The Privacy Policy page component.
 */
const Privacy: React.FC = () => {
  const handleClose = () => {
    window.close();
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Button
          startIcon={<Close />}
          onClick={handleClose}
          variant="outlined"
          sx={{ mb: 2 }}
        >
          Close
        </Button>
        <Typography variant="h3" component="h1" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Last updated: {new Date().toLocaleDateString()}
        </Typography>
      </Box>

      <PrivacyContent />
    </Container>
  );
};

export default Privacy;
